import React from 'react';
import classNames from 'classnames';

import { LabeledCheckboxRadioInput } from '../checkbox-radio-input/labeled-checkbox-radio-input.component';

export type RadioGroupProps = {
  name: string;
  items: {
    value: string;
    label: string;
    helpText?: string;
    disabled?: boolean;
  }[];
  value?: string;
  defaultValue?: string;
  className?: string;
  horizontal?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export const RadioGroup = ({
  name,
  value,
  defaultValue,
  className,
  horizontal = false,
  hasError,
  disabled,
  items,
  onChange,
  onBlur,
}: RadioGroupProps) => (
  <div
    className={classNames(
      horizontal ? 'flex space-x-4' : 'space-y-3',
      className
    )}
  >
    {items.map(
      ({
        value: itemValue,
        label: itemLabel,
        helpText: itemHelpText,
        disabled: itemDisabled,
      }) => (
        <LabeledCheckboxRadioInput
          name={name}
          key={itemValue}
          value={itemValue}
          checked={value !== undefined ? value === itemValue : undefined}
          defaultChecked={
            defaultValue !== undefined ? defaultValue === itemValue : undefined
          }
          disabled={disabled || itemDisabled}
          type="radio"
          label={itemLabel}
          helpText={itemHelpText}
          hasError={hasError}
          onChange={onChange}
          onBlur={onBlur}
        />
      )
    )}
  </div>
);
